import CreatePartnerContainer from "../containers/CreatePartnerContainer";

const CreatePartnerPage = () => {
  return (
    <CreatePartnerContainer />
  );
};

export default CreatePartnerPage;
